import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProfileLauncherComponent } from './profile-launcher.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ProfileLauncherComponent
  ],
  exports: [
    ProfileLauncherComponent
  ]
})
export class ProfileLauncherModule {
}
